<template>
<div>
<div class="">
  <card  :no-padding="false" class="is-ghost m-b-16" v-if="isOther && !isPrivate">
    <tooltip-button :tooltip="this.$t('jobs.tooltipSendMsg')" @click="contactClicked">
      <spinner line-bg-color="#44c7f0" line-fg-color="#ffffff"  size="small" v-if="contactLoading"></spinner><p v-else>{{this.$t('jobs.contact')}}</p>
    </tooltip-button>
    <tooltip-button :tooltip="this.$t('jobs.tooltipEarn')" :isInverted="true" @click="referClicked">{{this.$t('jobs.referForJob')}}</tooltip-button>
  </card>
  <strong>{{this.$t('profile.jobPreferences')}}:</strong>
<!--  <card :no-padding="true">-->
<!--    <split-section class="split-section">-->
<!--      <template slot="left">-->
<!--        <div class="has-text-centered is-cursor-pointer" @click="openCertificate">-->
<!--          <div class="field marked-height">-->
<!--            <figure class="image">-->
<!--              <img v-if="mundoCryptoStatus === 'Unattached'" src="@/assets/mundo-crypto-unattach.png" alt="resume icon">-->
<!--              <img v-else src="@/assets/mundo-crypto-attach.png" alt="resume icon">-->
<!--            </figure>-->
<!--          </div>-->
<!--          <strong>Mundo Crypto Cert</strong>-->
<!--          <div class="field">-->
<!--            <span>{{ mundoCryptoStatus }}</span>-->
<!--          </div>-->
<!--        </div>-->
<!--      </template>-->
<!--      <template slot="right">-->
<!--        <div class="has-text-centered">-->
<!--          <div class="field marked-height">-->
<!--            <figure class="image">-->
<!--              <img v-if="resumeStatus === 'Unattached'" src="@/assets/cv-attached-no.svg" alt="resume icon">-->
<!--              <img v-else src="@/assets/cv-logo.svg" alt="resume icon">-->
<!--            </figure>-->
<!--          </div>-->
<!--          <heading>{{this.$t('profile.CV')}}</heading>-->
<!--          <div class="field">-->
<!--            <span>{{ resumeStatus }}</span>-->
<!--          </div>-->
<!--        </div>-->
<!--        </template>-->
<!--    </split-section>-->
<!--  </card>-->
 <div class="cards">
   <card>
     <strong>{{this.$t('profile.roles')}}:</strong>
     <text-block>{{ formattedRoles }}</text-block>
   </card>
   <card>
     <strong>{{this.$t('profile.salary')}}:</strong>
     <span>{{ formattedSalary }}</span>
   </card>
   <card v-if="formattedContracts">
     <strong>{{this.$t('profile.contractTypes')}}:</strong>
     <span>{{ formattedContracts }}</span>
   </card>
   <card v-if="formattedNoticePeriod">
     <strong>{{this.$t('profile.noticePeriod')}}:</strong>
     <span>{{ formattedNoticePeriod }}</span>
   </card>
   <card v-if="jobBoards.length > 0">
     <strong>{{this.$t('profile.jobsBoard')}}:</strong>
     <div class="is-flex-direction-row">
       <img v-if="jobBoards.length > 0" v-for="jobSeekerBoard in jobBoards" v-tooltip="talentPoolName(jobSeekerBoard)" :src="jobSeekerImage(jobSeekerBoard.id,jobSeekerBoard.image)" :alt="jobSeekerBoard.name" class="logo-image" :key="jobSeekerBoard.id">
     </div>
   </card>
   <card v-if="editable" class="has-text-centered" >
     <a v-if="isPrivate">{{this.$t('profile.viewAll')}} </a>
     <a v-else @click.prevent="viewAllClicked">{{this.$t('profile.edit')}}</a>
   </card>
 </div>
</div>
  <p class="has-text-centered" v-if="!isPrivate">
  {{this.$t('profile.thisMeans')}} {{ isOther ? firstName : this.$t('profile.you') }} {{this.$t('profile.phraseCriteria')}}
  </p>
</div>
</template>

<script>
import TooltipButton from '@/components/general/tooltip-button'
import Card from '@/components/general/card'
import SplitSection from '@/components/general/split-section'
import Toggle from '@/components/toggle'
import Heading from '@/components/general/heading'
import TextBlock from '@/components/general/text-block'
import Spinner from 'vue-simple-spinner'
import { mapActions, mapState } from 'vuex'
import {capitalizeFirstLetter} from '../../helpers/general-helpers'

export default {
  components: { Toggle, Card, SplitSection, Heading, TooltipButton, TextBlock, Spinner },
  props: {
    profile: {
      type: Object,
      default: () => {}
    },
    user: {
      type: Object,
      default: () => {}
    },
    isOther: {
      type: Boolean,
      required: true
    },
    contactLoading: {
      type: Boolean,
      default: false
    },
    editable: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    ...mapActions('jobseekerProfiles', [
      'updateJobseekerProfile',
      'updateJobseekerProfileVisibility'
    ]),
    openCertificate () {
      if (this.profile && this.profile.mundoCryptoCer) {
        window.open(this.profile.mundoCryptoCer, '_blank')
      }
    },
    viewAllClicked () {
      this.$emit('view')
    },
    contactClicked () {
      this.$emit('contact')
    },
    referClicked () {
      this.$emit('refer')
    },
    talentPoolName (talentPool) {
      return talentPool.name
    },
    jobSeekerImage (boardId, imageUrl) {
      return imageUrl || `/api/identicons/${boardId}`
    }
  },
  computed: {
    ...mapState('jobseekers', ['jobSeekersBoard']),
    isPrivate () {
      if (this.profile) {
        return this.profile.status === 'private'
      }
      return false
    },
    toggleTooltip () {
      return this.checked ? this.$t('profile.tooltipView') : this.$t('profile.tooltipHidden')
    },
    checked: {
      get () {
        if (this.profile) return this.profile.isPublic
        return this.isPublic
      },
      set (value) {
        this.isPublic = value
        this.updateJobseekerProfileVisibility({isPublic: value})
      }
    },
    firstName () {
      if (this.profile) {
        return this.profile.firstName
      }
      return ''
    },
    isEditable () {
      return !this.isOther
    },
    formattedAccess () {
      return this.checked ? this.$t('profile.roleInPublic') : this.$t('profile.roleInPrivate')
    },
    formattedRoles () {
      if (this.profile && this.profile.roles && this.profile.roles.length > 0) {
        return this.profile.roles.join(', ')
      } else {
        if (this.user) {
          return `${this.user.lastName} hasn't shared this yet`
        }
      }
    },
    formattedSalary () {
      if (this.profile && this.profile.salary) {
        return `$${this.profile.salary.toLocaleString()} (min)`
      } else {
        if (this.user) {
          return `${this.user.lastName} hasn't shared this yet`
        }
      }
    },
    formattedNoticePeriod () {
      if (this.profile && this.profile.noticePeriod) {
        return `${this.profile.noticePeriod} days`
      } else {
        if (this.user) {
          return ''
        } else {
          return ''
        }
      }
    },
    formattedContracts () {
      if (this.profile && this.profile.contracts.length > 0) {
        return this.profile.contracts.map(contract => capitalizeFirstLetter(contract)).join(', ')
      } else {
        return ''
      }
    },
    jobBoards () {
      if (this.profile && this.profile.hasOwnProperty('talentPools')) {
        return this.profile.talentPools
      }
      return []
    },
    resumeStatus () {
      if (this.profile) {
        const resumeUrl = this.profile.resumeUrl
        if (resumeUrl || resumeUrl === 'attached') {
          return this.$t('profile.statusAttached')
        }
      }
      return this.$t('profile.statusUnattached')
    },
    mundoCryptoStatus () {
      if (this.profile) {
        const mundoCryptoCer = this.profile.mundoCryptoCer
        if (mundoCryptoCer) {
          return this.$t('profile.statusAttached')
        }
      }
      return this.$t('profile.statusUnattached')
    }
  },
  data () {
    return {
      isPublic: true
    }
  }
}
</script>

<style lang="scss" scoped>
.cards {
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);
}
div.field {
  display: block;
}

div.card-content a {
  text-align: center;
  font-weight: bold;
}

.field.marked-height {
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 1rem;
}

.field {
  margin-bottom: 0.5rem;
}

.field:last-child {
  margin-bottom: 0;
}

h6.heading {
  margin-bottom: 0.5rem;
}

.cards {
  .card:not(:last-child) {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }
  .card:not(:first-child) {
    border-top: 0;
    border-top-right-radius: 0;
    border-top-left-radius: 0;
  }
}

strong {
  display: block;
  margin-bottom: 0.5rem;
}
p {
  padding: 0.5rem 1rem;
  font-size: 0.75rem;
  line-height: 1.5;
}

.button:not(:last-child) {
  margin-bottom: 1rem;
}

.logo-image{
  width: 24px;
  height: 24px;
  margin-right: 10px;
}
.mb-20{
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/jobseekers/jobseeker-card.vue